import { apiClient } from "../../api/services/api.service";

/* ── Types API ── */

export interface IncoherenceDecision {
  id: string;
  numero: string;
  numero_rg: string;
  juridiction: string;
  ville: string;
  matiere: string;
  date_decision: string;
  statut: string;
}

export interface ValeurIncoherence {
  page: number;
  valeur: string;
  emplacement: string;
}

export interface Incoherence {
  id: string;
  decision: IncoherenceDecision;
  titre: string;
  type: string;
  gravite: 'majeure' | 'a_verifier' | 'information';
  valeurs: ValeurIncoherence[];
  objets_lies: { ref: string; type: string }[];
  description: string;
  verbatim: string;
  statut: 'a_examiner' | 'confirmee' | 'ignoree' | 'corrigee';
  commentaire: string;
  decidee_par: string | null;
  decidee_le: string | null;
  created_at: string;
}

export interface IncoherencesListResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: Incoherence[];
}

export interface IncoherencesStats {
  a_examiner: number;
  confirmees: number;
  ignorees: number;
  corrigees: number;
  decisions_concernees: number;
}

export interface JuridictionStats {
  juridiction: string;
  points: number;
  majeurs: number;
  decisions: number;
}

export interface IncoherencesFilters {
  statut?: string;
  gravite?: string;
  matiere?: string;
  juridiction?: string;
  date_debut?: string;
  date_fin?: string;
  limit?: number;
  offset?: number;
}

/* ── Appels API ── */

/** Liste paginée des incohérences avec filtres */
export const fetchIncoherences = async (params?: IncoherencesFilters) =>
  await apiClient.get<IncoherencesListResponse>('/incoherences/', { params });

/** Page suivante / précédente (URL complète) */
export const fetchIncoherencesPage = async (fullUrl: string) =>
  await apiClient.get<IncoherencesListResponse>(fullUrl);

/** Détail d'une incohérence */
export const fetchIncoherenceDetail = async (id: string) =>
  await apiClient.get<Incoherence>(`/incoherences/${id}/`);

/** Statistiques (mêmes filtres que la liste) */
export const fetchIncoherencesStats = async (params?: IncoherencesFilters) =>
  await apiClient.get<IncoherencesStats>('/incoherences/stats/', { params });

/** Répartition par juridiction */
export const fetchIncoherencesParJuridiction = async (params?: IncoherencesFilters) =>
  await apiClient.get<JuridictionStats[]>('/incoherences/par-juridiction/', { params });

/** Changer le statut d'une incohérence */
export const updateIncoherenceStatut = async (
  id: string,
  body: { statut: 'confirmee' | 'ignoree' | 'corrigee'; commentaire?: string },
) => await apiClient.post<Incoherence>(`/incoherences/${id}/statut/`, body);
